import { config } from '../config';

const PRODUCT_NAME = 'Crate Hackers';

/**
 * Major version of the running app. config.VERSION is REACT_APP_VERSION, which
 * .env resolves from package.json at build time, so this follows the release
 * version without anyone editing copy for a new major.
 */
export const getAppMajorVersion = (
  version: string = config.VERSION,
): string => {
  const major = /^\s*(\d+)\./.exec(version)?.[1];
  return major && major !== '0' ? major : '';
};

/**
 * Product name including the major version, e.g. "Crate Hackers 12". Falls back
 * to the bare product name when the version is missing or is the placeholder
 * config default, so copy never renders a wrong or half-substituted number.
 */
export const getVersionedProductName = (
  version: string = config.VERSION,
): string => {
  const major = getAppMajorVersion(version);
  return major ? `${PRODUCT_NAME} ${major}` : PRODUCT_NAME;
};
